import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Instagram, Facebook } from 'lucide-react';
import './Footer.css';
import { companyInfo } from '../mock';

const Footer = ({ contactInfo }) => {
  const phone = contactInfo?.phone || companyInfo.contact.phone;
  const email = contactInfo?.email || companyInfo.contact.email;
  const address = contactInfo?.address || companyInfo.contact.address;
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-container">
              <img src="/logo.png" alt="Efruz İnşaat" className="footer-logo-image" />
              <span className="footer-logo-text">EFRUZ İNŞAAT</span>
            </div>
            <p className="footer-tagline">{companyInfo.tagline}</p>
            <div className="footer-social">
              <a href={companyInfo.social.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
                <Linkedin size={20} />
              </a>
              <a href={companyInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="social-link">
                <Instagram size={20} />
              </a>
              <a href={companyInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="social-link">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Hızlı Bağlantılar</h4>
            <ul className="footer-links">
              <li><Link to="/">Ana Sayfa</Link></li>
              <li><Link to="/about">Hakkımızda</Link></li>
              <li><Link to="/services">Hizmetlerimiz</Link></li>
              <li><Link to="/projects">Projelerimiz</Link></li>
              <li><Link to="/references">Referanslarımız</Link></li>
              <li><Link to="/contact">İletişim</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Hizmetlerimiz</h4>
            <ul className="footer-links">
              <li>Lüks Konut Projeleri</li>
              <li>Ticari Yapılar</li>
              <li>Proje Yönetimi</li>
              <li>Anahtar Teslim Projeler</li>
              <li>Mimari Danışmanlık</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">İletişim</h4>
            <ul className="footer-contact">
              <li>
                <Phone size={18} />
                <span>{phone}</span>
              </li>
              <li>
                <Mail size={18} />
                <span>{email}</span>
              </li>
              <li>
                <MapPin size={18} />
                <span>{address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              <p>&copy; 2025 Efruz İnşaat. Tüm hakları saklıdır.</p>
              <span style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '14px' }}>|</span>
              <a 
                href="https://aslunox.com" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  color: 'rgba(255, 255, 255, 0.7)', 
                  textDecoration: 'none', 
                  fontSize: '14px', 
                  transition: 'color 0.3s ease' 
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = 'var(--accent-gold)';
                  if (e.target.querySelector('img')) {
                    e.target.querySelector('img').style.opacity = '1';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.7)';
                  if (e.target.querySelector('img')) {
                    e.target.querySelector('img').style.opacity = '0.7';
                  }
                }}
              >
                <span>Tasarım & Geliştirme:</span>
                <img 
                  src="/aslunoxlogo.png" 
                  alt="Aslunox" 
                  style={{ 
                    height: '28px', 
                    width: 'auto', 
                    opacity: '0.7',
                    transition: 'opacity 0.3s ease'
                  }} 
                />
              </a>
            </div>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              <Link to="/legal/gizlilik-politikasi" style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = 'var(--accent-gold)'} onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}>
                Gizlilik Politikası
              </Link>
              <Link to="/legal/kullanim-sartlari" style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = 'var(--accent-gold)'} onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}>
                Kullanım Şartları
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
